package de.emgress.baskets.core.extensions

import de.emgress.baskets.core.styles.Styles
import org.w3c.dom.Window

fun Window.isMobile(): Boolean {
    return this.innerWidth <= Styles.cssConstants.breakPointMobile
}